import { onceAny } from '../events/once';

const PollingTimout: number = 2.5;

export const activityEvents: Array<string> = [
    'click',
    'mousemove',
    'scroll',
    'keydown',
    'touchstart',
];

export function trackActivity( callback: ( event: Event ) => void ): void {
    onceAny( document, activityEvents, callback );
}

/**
 * trackInactivity invokes a function once the user is inactive for the limit specified
 * @param {number} limit - the inactivity limit in seconds
 * @param {function} callback - a function to invoke when the limit is reached
 */
function trackInactivity( id: string, limit: number, callback?: () => void ): number {
    if ( !window.idleTimers ) {
        window.idleTimers = {} as Record<string, number>;
    }

    if ( window.idleTimers && window.idleTimers[ id ] ) {
        window.clearInterval( window.idleTimers[ id ] );
    }

    let idleSecondsCounter = 0;

    const passive = {
        passive: true,
    };

    const resetCounter = (): void => {
        idleSecondsCounter = 0;
    };

    activityEvents.forEach( ( eventName: string ) => {
        document.addEventListener( eventName, resetCounter, passive );
    } );

    const checkTimeout = (): void => {
        idleSecondsCounter += PollingTimout;

        if ( idleSecondsCounter >= limit ) {
            window.clearInterval( window.idleTimers[ id ] );

            if ( callback ) {
                callback();
            }
        }
    };

    window.idleTimers[ id ] = window.setInterval( checkTimeout, PollingTimout * 1000 );

    return window.idleTimers[ id ];
}

export {
    trackInactivity,
};
